
import { Component, Prop, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import { emptyToLine } from "@common/src/utils/common";
import { addCurrencyUnit } from "@common/src/utils/tools";
import { namespace } from "vuex-class";

const service = namespace("service");
const setting = namespace("setting");
const store = namespace("store");
@Component({})
export default class DelegatePrint extends Vue {
  @service.Action getPrintStoreLogo;
  @setting.Action queryPrintFieldListByCategory;
  @setting.Action queryPrintFieldListByCode;
  @store.State storeData;
  @Prop({ default: () => ({}), type: Object })
  orderData: any;
  @Prop({ default: "" })
  printTemplateCode: string;
  dayjs = dayjs;
  printLogo: string = "https://static.gtech.asia/static/speedbiz/speedbiz_logo.png";
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;

  get $orderData() {
    return this.orderData;
  }
  created() {
    this.getLogoImg();
    this.getTemplateField();
  }
  getLogoImg() {
    this.getPrintStoreLogo().then(res => {
      this.printLogo = res.data.storeLogo;
    });
  }
  fieldList: any = [];
  customerNotice = "";
  storeNameBySource: "";
  get availableFieldArr() {
    return this.fieldList.filter(item => item.status === 1).map(item => item.fieldCode);
  }
  queryPrintTemplateCode = "";
  getTemplateField() {
    const queryFn = this.isPreview ? this.queryPrintFieldListByCode : this.queryPrintFieldListByCategory;
    const queryParams = this.isPreview
      ? { printTemplateCode: this.printTemplateCode }
      : { category: "PRINT_DELEGATION_CREDENTIALS" };
    queryFn(queryParams).then(data => {
      this.fieldList = data.data?.printFieldList || [];
      this.customerNotice = data.data?.customerNotice || "";
      this.queryPrintTemplateCode = data.data?.printTemplateCode;
      this.templateServicePhone = data.data?.templateServicePhone || "";
      this.storeNameBySource = data.data?.storeName || "";
    });
  }
  get customerNoticeList() {
    return this.customerNotice.split("\n");
  }
  get isThree() {
    return (
      this.queryPrintTemplateCode === "PRINT_PAYMENT_CREDENTIALS_THREE" ||
      this.queryPrintTemplateCode === "PRINT_DELEGATION_CREDENTIALS_THREE"
    );
  }
  get isPreview() {
    return !!this.printTemplateCode;
  }
  templateServicePhone: string = "";
}
